import React from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

interface ScrollRevealProps {
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly threshold?: number;
}

export function ScrollReveal({ children, className = '', threshold = 0.1 }: Readonly<ScrollRevealProps>): React.ReactElement {
  const [elementRef, isVisible] = useScrollReveal({ threshold });

  return (
    <div
      ref={elementRef}
      className={`reveal-on-scroll ${isVisible ? 'visible' : ''} ${className}`}
    >
      {children}
    </div>
  );
}
